import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={36.807}
      height={27.432}
      viewBox="0 0 36.807 27.432"
      {...props}
    >
      <g data-name="Group 518" fill="#fff">
        <path
          data-name="Path 10857"
          d="M0 8.277a1.848 1.848 0 001.845 1.845h33.113a1.848 1.848 0 001.845-1.845V0H0zm7.422-5.111h14.043a1.1 1.1 0 010 2.2H7.422a1.1 1.1 0 110-2.2zm-4.906 0h.586a1.1 1.1 0 110 2.2h-.586a1.1 1.1 0 110-2.2z"
        />
        <path
          data-name="Path 10859"
          d="M3.869 13.935a1.617 1.617 0 001.615 1.615h25.839a1.617 1.617 0 001.618-1.615V12.32H3.871z"
        />
        <path
          data-name="Path 10860"
          d="M6.48 17.751h23.847a1.5 1.5 0 011.5 1.5v.231a1.5 1.5 0 01-1.5 1.5H6.48a1.5 1.5 0 01-1.5-1.5v-.231a1.5 1.5 0 011.5-1.5z"
        />
        <path
          data-name="Path 10861"
          d="M14.484 27.431h7.85a6.106 6.106 0 005.827-4.251h-19.5a6.107 6.107 0 005.827 4.251z"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
